import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { GeneticMaterialCrossingTypeService } from '../proxy/general/controllers/genetic-material-crossing-type.service';
import { GeneticMaterialService } from '../proxy/general/controllers/genetic-material.service';

FieldBuilder.setNamespace('General');

export const GENETICMATERIALCROSSING_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.GeneticMaterialCrossing.Name')
    .required()
    .minLength(1)
    .maxLength(200)
    .build(),
  FieldBuilder
    .foreignKey('geneticMaterialCrossingTypeId', 'Entity.GeneticMaterialCrossingType', GeneticMaterialCrossingTypeService)
    .required()
    .displayFromNested('geneticMaterialCrossingType.name')
    .sortBy('geneticMaterialCrossingType.name')
    .build(),
  FieldBuilder
      .foreignKey('maleGeneticMaterialId', 'Entity.GeneticMaterialCrossing.MaleGeneticMaterial', GeneticMaterialService)
    .required()
    .displayFromNested('maleGeneticMaterial.name')
    .sortBy('maleGeneticMaterial.name')
    .build(),
  FieldBuilder
      .foreignKey('femaleGeneticMaterialId', 'Entity.GeneticMaterialCrossing.FemaleGeneticMaterial', GeneticMaterialService)
    .required()
    .displayFromNested('femaleGeneticMaterial.name')
    .sortBy('femaleGeneticMaterial.name')
    .build(),
];

export const GENETICMATERIALCROSSING_CONFIG = {
  entityName: 'GeneticMaterialCrossing',
  localizationKey: 'General::Entity.GeneticMaterialCrossing',
  fields: GENETICMATERIALCROSSING_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.GeneticMaterialCrossings',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
